export const emptyMessage = {
  modalTitle: "Notifications",
  emptyTitle: "You have no notifications",
  emptyDescription:
    "Check back later for the latest promotions, alerts and info"
};
